import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { IApiParams } from '../interface/IApiParams';
import { getApi2 } from './getApi2';

export const apiPlayerSetupGet = async (
  id: string,
  key: string,
  route: string,
  accessToken: string,
  apiVersion: string,
  secureToken: string
) => {
  const params: IApiParams = {
    url: `/playerSetup.php?accessToken=${accessToken}&id=${id}&key=${key}&route=${route}&apiVersion=${apiVersion}&secureToken=${secureToken}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi2(params, 'GET');
};
